import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const ResourceViewer = ({ resource, open, onOpenChange }) => {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open || !resource) return;
    let objectUrl;
    let cancelled = false;
    setUrl(null);
    setError("");
    api
      .get(`/resources/${resource.id}/preview`, { responseType: "blob" })
      .then((res) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(res.data);
        setUrl(objectUrl);
      })
      .catch(() => !cancelled && setError("Aperçu indisponible pour ce fichier."));
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [open, resource]);

  const body = () => {
    if (error) return <p className="text-sm text-red-600">{error}</p>;
    if (!url)
      return (
        <div className="flex items-center gap-3 text-[#B76E79] py-20 justify-center">
          <Loader2 className="w-5 h-5 animate-spin" strokeWidth={1.5} />
          <span className="font-display text-xl">Chargement de l'aperçu…</span>
        </div>
      );
    if (resource.kind === "video")
      return <video data-testid="viewer-video" src={url} controls className="w-full rounded-2xl bg-black max-h-[70vh]" />;
    if (resource.kind === "audio")
      return (
        <div className="py-10 px-6 bg-[#FDFBF7] rounded-2xl">
          <audio data-testid="viewer-audio" src={url} controls className="w-full" />
        </div>
      );
    if (resource.kind === "image")
      return (
        <img
          data-testid="viewer-image"
          src={url}
          alt={resource.title}
          className="w-full max-h-[70vh] object-contain rounded-2xl bg-[#FDFBF7]"
        />
      );
    return (
      <iframe
        data-testid="viewer-frame"
        title={resource.title}
        src={url}
        className="w-full h-[70vh] rounded-2xl border border-[#E8D7D0] bg-white"
      />
    );
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="resource-viewer"
        className="max-w-4xl bg-white border-[#E8D7D0] rounded-3xl"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-[#2C2627] text-left">
            {resource?.title}
          </DialogTitle>
        </DialogHeader>
        {resource && body()}
      </DialogContent>
    </Dialog>
  );
};
